// Host-only configuration: the shared SDK never imports Redux or environment.
export function createAnalyticsConfig({ env, appVersion, getState, getPagePath, storage }) {
  return {
    url: env.REACT_APP_ANALYTICS_URL,
    ingestKey: env.REACT_APP_ANALYTICS_INGEST_KEY,
    appId: 'medical-scribe-web', // server derives the app from its per-app key
    environment: env.REACT_APP_ENV || env.NODE_ENV,
    appVersion,
    getIdentity: () => {
      const s = getState().globalState;
      return { userId: s?.userDetails?.id, teamId: s?.currentOrg?.id, role: s?.role };
    },
    // Routes are static; the SDK also scrubs UUID/numeric path segments.
    getPagePath: () => getPagePath(),
    enabled: () => storage.getItem('tc_analytics_off') !== '1',
    // Scribe has no separate identity-consent setting. Preserve its existing
    // host policy: the analytics opt-out disables both events and identity.
    // The SDK otherwise strips identity when this callback is absent.
    getIdentityConsent: () => storage.getItem('tc_analytics_off') !== '1',
    // Never reads button text, aria-label, input values, or clinical content.
    autoCapture: { clicks: true, allClickables: true, views: false },
  };
}
